module.exports = __webpack_public_path__ + "img/warabee_top.6cbf6820.jpg";